const InComsSent = [
  'InitialCommsSent',
  'PostponeCommsSent',
  'RescheduleCommsSent',
  'CancellationCommsSent',
  'SuccessfulCommsSent',
  'UnsuccessfulCommsSent',
  'InitialCommsInProgress',
  'PostponeCommsInProgress',
  'RescheduleCommsInProgress',
  'CancellationCommsInProgress',
  'SuccessfulCommsInProgress',
  'UnsuccessfulCommsInProgress',
];

export { InComsSent };
